import css from "styled-jsx/css";

export const componentStyles = css`
  .manage-option-box {
    display: flex;
    align-items: center;
    height: 40px;
    margin: 12px 12px 0 0;
    padding: 0 16px;
    border-radius: 8px;
    cursor: pointer;
    border: 1px solid rgba(225, 225, 225, 1);
    user-select: none;

    .manage-option {
      font-size: 0.875rem;
      line-height: 30px;
    }

    &.selected {
      border: 1px solid transparent;
    }
  }
`;
